"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const fallbackPageRuntime = {
  pathname: "",
  pathParams: {},
  searchParams: {},
  slug: void 0,
  staticPage: void 0
};
const PageRuntimeContext = createContext(fallbackPageRuntime);
const PageRuntimeProvider = ({
  children,
  value
}) => /* @__PURE__ */ jsx(PageRuntimeContext.Provider, { value, children });
const usePageRuntime = () => useContext(PageRuntimeContext);
export {
  PageRuntimeProvider,
  usePageRuntime
};
//# sourceMappingURL=page-runtime.client.js.map
